import { SettingsMichiganTitleFeeDto } from 'dtos'
import { useEffect, useState } from 'react'
import * as controllers from 'controllers'
import MichiganTitleFeeAddEditDialog from './MichiganTitleFeeAddEditDialog'
import { enqueueSnackbar } from 'notistack'
import { Button, Card, CardContent, CircularProgress, Divider, Grid, Typography } from '@mui/material'
import { GreenText, LabelField } from 'components'
import { Edit } from '@mui/icons-material'

export default function MichiganTitleFeeListCard() {
  const [michiganTitleFee, setMichiganTitleFee] = useState<SettingsMichiganTitleFeeDto>(new SettingsMichiganTitleFeeDto())
  const [isMichiganTitleFeeSaving, setIsMichiganTitleFeeSaving] = useState<boolean>(false)
  const [michiganTitleFeeAddEditDialogOpen, setMichiganTitleFeeAddEditDialogOpen] = useState<boolean>(false)
  const [isGettingMichiganTitleFee, setIsGettingMichiganTitleFee] = useState<boolean>(false)

  useEffect(() => {
    setIsGettingMichiganTitleFee(true)
    controllers
      .getMichiganTitleFee()
      .then(response => {
        setMichiganTitleFee(response.value)
      })
      .finally(() => {
        setIsGettingMichiganTitleFee(false)
      })
  }, [])

  return (
    <>
      <MichiganTitleFeeAddEditDialog
        initialValues={michiganTitleFee}
        isLoading={isMichiganTitleFeeSaving}
        onClose={() => {
          setMichiganTitleFeeAddEditDialogOpen(false)
        }}
        onSave={values => {
          setIsMichiganTitleFeeSaving(true)
          controllers
            .updateMichiganTitleFee(values)
            .then(response => {
              enqueueSnackbar('Michigan Title Fee Saved Successfully', { variant: 'success' })
              setMichiganTitleFee(response.value)
              setMichiganTitleFeeAddEditDialogOpen(false)
            })
            .finally(() => {
              setIsMichiganTitleFeeSaving(false)
            })
        }}
        open={michiganTitleFeeAddEditDialogOpen}
      />
      <Card>
        <CardContent>
          <Grid container spacing={1} alignItems='flex-start'>
            <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
              <Grid item xs={12} sm='auto'>
                <Typography fontWeight='bold' variant='h5'>
                  Michigan Title Fee
                </Typography>
              </Grid>

              <Grid item xs={12} sm='auto'>
                <Button onClick={() => setMichiganTitleFeeAddEditDialogOpen(true)} variant='text' endIcon={<Edit />}>
                  Edit
                </Button>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            {isGettingMichiganTitleFee && (
              <Grid item container alignItems='center' justifyContent='center' sx={{ my: 1 }}>
                <Grid>
                  <CircularProgress color='primary' size={50} />
                </Grid>
              </Grid>
            )}

            {!isGettingMichiganTitleFee && (
              <Grid item xs={12}>
                <LabelField
                  value={
                    michiganTitleFee.michiganTitleFee !== undefined && michiganTitleFee.michiganTitleFee !== null
                      ? `$${michiganTitleFee.michiganTitleFee.toFixed(2)}`
                      : '$0.00'
                  }
                />
              </Grid>
            )}

            <Grid item xs={12}>
              <GreenText variant='outlined'>
                {`**Michigan Title Fee Card:**

The Michigan Title Fee Card is designed to display and manage the fee used for the
Michigan Title Application RD-108 form.

---

**Edit Button:**

Clicking the Edit button opens the Michigan Title Fee Dialog, allowing users to enter
or modify the title fee amount.

---

**Title Fee Label:**

Shows the dollar amount entered in the Michigan Title Fee Dialog.

Default Value: $0.00 (if no value has been set).

---
`}
              </GreenText>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  )
}
